import { useContext, useEffect } from 'react'
import { CheckBox } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import WithdrawIcon from '@nv/images/design/withdraw-icon'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import styles from './RejectNomination.module.scss'

export const RejectNomination = ({ confirm, title }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const formik = useFormik({
    initialValues: {
      consent: false,
    },
    validationSchema: Yup.object({
      consent: Yup.boolean().oneOf([true], t('You must agree to the terms')),
    }),
    onSubmit: () => {
      confirm()
    },
  })

  useEffect(() => {
    setHeaderLabel(t('Reject Nomination'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.confirm'), onClick: formik.handleSubmit },
    ])
  }, [])

  return (
    <div className={styles['container']}>
      <WithdrawIcon />
      <span className={styles['title']}>{t(`Youre rejecting a nomination for ${title}.`)}</span>
      <div className={styles['consent']}>
        <CheckBox
          checked={formik.values.consent}
          onChange={() => formik.setFieldValue('consent', !formik.values.consent)}
          formik={formik}
          field='consent'
          label={t(
            'By selecting this option, I confirm that I have read and agree to the Terms and Conditions, and I reject all the stated terms. I understand that rejecting my candidacy is final and cannot be undone.',
          )}
        />
      </div>
    </div>
  )
}
